import variables from "@/assets/styles/export.module.scss";

export default {
  install(Vue) {
    Vue.prototype.$theme = variables;
  },
};
